export default function (email, setUser, serverOrigin) {
	return new Promise((resolve, reject) => {
		let body = JSON.stringify({
			email: email,
		});
		fetch(serverOrigin + '/login', {
			method: 'post',
			credentials: 'include',
			headers: {'Content-Type': 'application/json'},
			body: body,
		})
			.then(res => {
				return res.json();
			})
			.then(profileInfo => {
				console.log('Sign in fetch was successfully done.');
				if (profileInfo.loggedIn) {
					setUser(profileInfo.user);
					localStorage.setItem('userID', profileInfo.user._id);
					resolve(profileInfo.user);
				} else {
					reject({
						message: 'User not logged in with API',
					});
				}
			})
			.catch(err => {
				console.error('Something went wrong in the sign in fetch api reqest because ' + err.message);
			});
	});
}
